import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutConst, useModal } from 'core';
import { useToasts } from '@brg/ui';
import styled from 'styled-components';
import urlApi from 'shared/actions/urlApi';
import { LoaderSpinner } from 'shared/modals/artzLegalsModal/LoaderAnimation';
import { EventRegistrationForm } from 'shared/pages/teams/components/RegistrationFormComponent';
import { submitTeamFormAnswer } from 'shared/pages/teams/helpers/submitTeamFormAnswer';
import { SHOP_APPLICATION_FORM_ID } from './constants';

const ModalScrollWrapper = styled.div`
    width: 740px;
    max-width: calc(100vw - 32px);
    max-height: calc(100vh - 48px);
    overflow-y: auto;
    margin: 24px auto;
    background: ${({ theme }) => theme.mainBg};
    border-radius: 8px;
    padding: 32px 16px;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100vw - 24px);
        max-height: calc(100vh - 32px);
        padding: 24px 12px;
        margin: 16px auto;
    }
`;

type ShopApplicationModalProps = {
    teamId: string;
    onSubmitted?: () => void;
};

export const ShopApplicationModal: FC<ShopApplicationModalProps> = ({ teamId, onSubmitted }) => {
    const modal = useModal();
    const toasts = useToasts();
    const { t, i18n: { language } } = useTranslation();
    const [isPpdAccepted, setIsPpdAccepted] = useState(true);
    const [formData, setFormData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const submitLockRef = useRef(false);

    useEffect(() => {
        let cancelled = false;

        urlApi()
            .getForm(SHOP_APPLICATION_FORM_ID)
            .then((response) => response.json())
            .then((form) => {
                if (!cancelled) {
                    setFormData(form);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    toasts.error(t('teams.adminPage.servicesTabs.shopApplicationFormLoadError'));
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    const handleClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    const handleSubmit = useCallback((values: Record<string, unknown>) => {
        if (!formData || submitLockRef.current || isSubmiting) {
            return;
        }

        submitLockRef.current = true;
        setIsSubmiting(true);

        submitTeamFormAnswer({
            formId: SHOP_APPLICATION_FORM_ID,
            formData,
            values,
            language,
            isPpdAccepted,
            teamId,
        })
            .then((response) => {
                if (response?.status === 200) {
                    toasts.info(t('teams.adminPage.servicesTabs.shopApplicationSuccess'));
                    onSubmitted?.();
                    modal.hide();
                    return;
                }

                toasts.error(t('teams.adminPage.servicesTabs.shopApplicationError'));
            })
            .catch(() => {
                toasts.error(t('teams.adminPage.servicesTabs.shopApplicationError'));
            })
            .finally(() => {
                submitLockRef.current = false;
                setIsSubmiting(false);
            });
    }, [formData, isPpdAccepted, isSubmiting, language, modal, onSubmitted, t, teamId, toasts]);

    if (isLoading) {
        return (
            <ModalScrollWrapper>
                <LoaderSpinner color="#909090" />
            </ModalScrollWrapper>
        );
    }

    if (!formData) {
        return null;
    }

    return (
        <ModalScrollWrapper>
            <EventRegistrationForm
                skipFetch
                isModal
                onCancel={handleClose}
                cancelText={t('close')}
                data={formData}
                initialValues={{}}
                onSubmit={handleSubmit}
                isPpdAccepted={isPpdAccepted}
                setIsPpdAccepted={setIsPpdAccepted}
                isSubmiting={isSubmiting}
            />
        </ModalScrollWrapper>
    );
};
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutConst, useModal } from 'core';
import { useToasts } from '@brg/ui';
import styled from 'styled-components';
import urlApi from 'shared/actions/urlApi';
import { LoaderSpinner } from 'shared/modals/artzLegalsModal/LoaderAnimation';
import { EventRegistrationForm } from 'shared/pages/teams/components/RegistrationFormComponent';
import { submitTeamFormAnswer } from 'shared/pages/teams/helpers/submitTeamFormAnswer';
import { SHOP_APPLICATION_FORM_ID } from './constants';

const ModalScrollWrapper = styled.div`
    width: 740px;
    max-width: calc(100vw - 32px);
    max-height: calc(100vh - 48px);
    overflow-y: auto;
    margin: 24px auto;
    background: ${({ theme }) => theme.mainBg};
    border-radius: 8px;
    padding: 32px 16px;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100vw - 24px);
        max-height: calc(100vh - 32px);
        padding: 24px 12px;
        margin: 16px auto;
    }
`;

type ShopApplicationModalProps = {
    teamId: string;
    onSubmitted?: () => void;
};

export const ShopApplicationModal: FC<ShopApplicationModalProps> = ({ teamId, onSubmitted }) => {
    const modal = useModal();
    const toasts = useToasts();
    const { t, i18n: { language } } = useTranslation();
    const [isPpdAccepted, setIsPpdAccepted] = useState(true);
    const [formData, setFormData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const submitLockRef = useRef(false);

    useEffect(() => {
        let cancelled = false;

        urlApi()
            .getForm(SHOP_APPLICATION_FORM_ID)
            .then((response) => response.json())
            .then((form) => {
                if (!cancelled) {
                    setFormData(form);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    toasts.error(t('teams.adminPage.servicesTabs.shopApplicationFormLoadError'));
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, []);

    const handleClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    const handleSubmit = useCallback((values: Record<string, unknown>) => {
        if (!formData || submitLockRef.current || isSubmiting) {
            return;
        }

        submitLockRef.current = true;
        setIsSubmiting(true);

        submitTeamFormAnswer({
            formId: SHOP_APPLICATION_FORM_ID,
            formData,
            values,
            language,
            isPpdAccepted,
            teamId,
        })
            .then((response) => {
                if (response?.status === 200) {
                    toasts.info(t('teams.adminPage.servicesTabs.shopApplicationSuccess'));
                    onSubmitted?.();
                    modal.hide();
                    return;
                }

                toasts.error(t('teams.adminPage.servicesTabs.shopApplicationError'));
            })
            .catch(() => {
                toasts.error(t('teams.adminPage.servicesTabs.shopApplicationError'));
            })
            .finally(() => {
                submitLockRef.current = false;
                setIsSubmiting(false);
            });
    }, [formData, isPpdAccepted, isSubmiting, language, modal, onSubmitted, t, teamId, toasts]);

    if (isLoading) {
        return (
            <ModalScrollWrapper>
                <LoaderSpinner color="#909090" />
            </ModalScrollWrapper>
        );
    }

    if (!formData) {
        return null;
    }

    return (
        <ModalScrollWrapper>
            <EventRegistrationForm
                skipFetch
                isModal
                onCancel={handleClose}
                cancelText={t('close')}
                data={formData}
                initialValues={{}}
                onSubmit={handleSubmit}
                isPpdAccepted={isPpdAccepted}
                setIsPpdAccepted={setIsPpdAccepted}
                isSubmiting={isSubmiting}
            />
        </ModalScrollWrapper>
    );
};
